<template>
  <div class="collect-invoice-window" style="padding: 10px 20px;">
    <el-form :inline="true" label-width="120px" label-position="left">
      <div style="display: flex;flex-direction: row;">
        <div style="flex: 1;">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_invoiceNo')" class="padding-bottom3">
              <el-input v-model="properties.invoice.invoiceNo" />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_invoicingDate')" class="padding-bottom3">
              <el-date-picker
                v-model="properties.invoice.invoiceDate"
                type="date"
                style="width: 170px"
                :clearable="false"
                :disabled="locked"
                @change="invoiceDateChange"
              />
            </el-form-item>
          </div>
          <!--开票抬头-->
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_invoiceHeader')" label-width="120px" style="padding-bottom: 3px;">
              <cargo-advance-select
                :select-type="selectTypeNames.static_data_Title"
                :allow-create="true"
                style="width: 240px"
                filterable
                :cache="false"
                :default-value="properties.invoice.title"
                :static-options="customerTitles"
                @parentCallBack="apTitleChangeEvent"
              />
            </el-form-item>
          </div>
          <!--收票抬头-->
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('CargoMsg.Cargo_ReceiptInvoiceTitle')" label-width="120px" style="padding-bottom: 3px;">
              <cargo-advance-select
                no="receiptInvoiceTitle"
                :select-type="selectTypeNames.static_data_InvoiceTitle"
                :allow-create="true"
                style="width: 240px"
                filterable
                :cache="false"
                :default-value="properties.invoice.receiptInvoiceTitle"
                :static-options="ourInvoiceTitleArray"
                @parentCallBack="apReceiptInvoiceTitleChangeEvent"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_exchangeRate')" class="padding-bottom3">
              <el-input v-model="rate" :disabled="true" style="width: 170px" />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_totalAmount')" class="padding-bottom3">
              <el-input v-model="properties.invoice.chineseAmount" :disabled="true" style="width: 170px" />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_total')" class="padding-bottom3">
              <div style="display: flex">
                <el-input-number
                  v-model="properties.invoice.amount"
                  :disabled="true"
                  :precision="2"
                  :step="1"
                  :min="-999999999999"
                  :max="999999999999"
                  style="width: 170px"
                  controls-position="right"
                />
              </div>
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_taxFreeAmount')" class="padding-bottom3">
              <el-input-number
                v-model="properties.invoice.excludingTaxAmount"
                :disabled="true"
                :precision="2"
                :step="1"
                :min="-999999999999"
                :max="999999999999"
                style="width: 170px"
                controls-position="right"
              />
            </el-form-item>
          </div>
          <div v-if="(eiTaxControlInterfaceName === 'NUONUO')" class="el-form-item-wrapper">
            <el-form-item :label="$t('CargoMsg.Cargo_InvoiceNature')" class="padding-bottom3">
              <cargo-advance-select
                no="invoiceNature"
                filterable
                :cache="false"
                :default-value="properties.invoice.invoiceNature"
                :static-options="INVOICE_NATURE"
                tag-value="code"
                :tag-name="isZh ? 'chineseName' : 'englishName'"
                style="width: 170px"
                @parentCallBack="apInvoiceNatureChangeEvent"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.billingJob_taxRate')" class="padding-bottom3">
              <el-input-number
                v-model="properties.invoice.taxRate"
                :disabled="apTaxRateReadonly"
                :precision="2"
                :step="1"
                :min="0"
                :max="100"
                style="width: 170px"
                controls-position="right"
                @change="taxRateChangeHandler"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_taxAmount')" class="padding-bottom3">
              <el-input-number
                v-model="properties.invoice.taxAmount"
                :precision="2"
                :step="1"
                :min="-999999999999"
                :max="999999999999"
                style="width: 170px"
                controls-position="right"
                @change="taxAmountChangeHandler"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_approvedBy')" class="padding-bottom3">
              <el-input v-model="properties.invoice.auditor" :disabled="true" style="width: 170px" />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_actualReceiptDate')" class="padding-bottom3">
              <el-date-picker
                v-model="properties.invoice.actualReceiptDate"
                style="width: 170px"
                :disabled="locked"
                type="date"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.paymentPeriod')" class="padding-bottom3-left40">
              <el-date-picker
                v-model="properties.invoice.paymentTerm"
                :disabled="locked"
                style="width: 170px"
                no="paymentTerm"
                type="date"
                :placeholder="incomePayDate"
              />
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('Invoice.invoice_notesOnReceipt')" class="padding-bottom3">
              <el-input v-model="properties.invoice.remark" :disabled="locked" type="textarea" resize="none" style="width: 170px" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_FinancialRemarks')" class="padding-bottom3-left40">
              <el-input v-model="properties.invoice.remark2" :disabled="locked" type="textarea" resize="none" style="width: 170px" />
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import { ApiCacheManage } from '@/utils/commonUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import { BPM_STATES_UN_APPROVED } from '@/class/cargo/model/parameters/SystemConstants'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import { cache, cacheName } from '@/utils/cacheManager'
import { InvoiceUtils } from '@/class/cargo/model/utils/InvoiceUtils'

export default {
  name: 'CollectInvoiceWindow',
  components: { cargoRichTextarea, CargoAdvanceSelect, BatchCheckingWindow, ChargeCurrencyTotalGroup, NumInput },
  props: {
    properties: { type: Object, required: true }
  },
  data() {
    return {
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      ourInvoiceTitleArray: [], // 我方发票抬头选项
      customerTitles: [], // 费用结算单位的开票抬头,
      selectTypeNames: TYPE_NAMES,
      INVOICE_NATURE: InvoiceConstant.INVOICE_NATURE,
      incomePayDate: '',
      eiTaxControlInterfaceName: false
    }
  },
  computed: {
    // 是否只读
    locked() {
      if (this.properties !== null && this.properties.invoice !== null) {
        if (this.properties.invoice.printed || (this.properties.invoice.revoked && !StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo)) || (!!this.properties.invoice.approvalStatus && this.properties.invoice.approvalStatus !== BPM_STATES_UN_APPROVED.code)) {
          return true
        }
      }
      return false
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    // 收票，税率是否可以修改
    apTaxRateReadonly() {
      if (this.properties.invoice.invoiceNature && this.properties.invoice.invoiceNature !== InvoiceConstant.INVOICE_NATURE_NORMAL.code) {
        return true
      }
      return false
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    // 汇率
    rate() {
      const rate = StrUtils.isEmpty(this.properties.invoice.chargeCurrency1) ? this.properties.invoice.rate : this.properties.invoice.chargeExchangeRate1
      return (StrUtils.isEmpty(rate)) ? '' : rate.toFixed(8)
    }
  },
  watch: {
    currentOfficeId: {
      immediate: true,
      async handler(newVal) {
        // 获取发票抬头列表
        this.getInvoiceTitlesByOfficeCache.execute({ officeId: newVal }).then(res => {
          if (newVal === this.currentOfficeId) {
            this.ourInvoiceTitleArray = res.data
          }
        })
      }
    },
    'properties.invoice.incomePayDate': {
      immediate: true,
      handler(newVal) {
        this.incomePayDate = newVal ? newVal.substr(0, 10) : ''
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.eiTaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
  },
  methods: {
    async initBaseData() {
      // 初始化开票抬头、收票抬头
      this.customerTitles = []
      if (!this.properties.invoice.ar && this.properties.invoice.chargeList && this.properties.invoice.chargeList.length > 0) {
        await InvoiceUtils.initTitlesMap(this.properties.invoice.chargeList, this)
      }
    },
    invoiceDateChange() {
      InvoiceUtils.invoiceDateChange(this)
    },
    // 应付发票开票抬头修改
    apTitleChangeEvent(titleItem) {
      InvoiceUtils.apTitleChangeEvent(this.properties.invoice, titleItem)
    },
    // 应付发票收票抬头修改
    apReceiptInvoiceTitleChangeEvent(titleItem) {
      InvoiceUtils.apReceiptInvoiceTitleChangeEvent(this.properties.invoice, titleItem)
    },
    // 应付发票发票性质修改
    apInvoiceNatureChangeEvent(p) {
      InvoiceUtils.apInvoiceNatureChangeEvent(this.properties.invoice, p.value)
    },
    // 税率
    taxRateChangeHandler(value) {
      InvoiceUtils.taxRateChangeHandler(this.properties.invoice)
    },
    // 计算不含税
    taxAmountChangeHandler(value) {
      InvoiceUtils.taxAmountChangeHandler(this.properties.invoice, value, this)
    }
  }
}
</script>

<style lang="scss" scoped>
.padding-bottom3 {
  padding-bottom: 3px;
}
.padding-bottom3-left40 {
  margin-left:40px;
  padding-bottom: 3px;
}
</style>
